module.exports = __webpack_public_path__ + "img/img0206.f4d1b6d7.png";